var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',[_c('p',[_vm._v("Du är inloggad som "),_c('strong',[_vm._v(_vm._s(_vm.currentMember.email))])]),_c('p',[_c('a',{attrs:{"href":"/profile"}},[_vm._v("Gå till profil >>")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }